export const useStyles = (theme) => ({
  root: {
    paddingTop: 20,
    paddingLeft: 50,
    paddingRight: 50,
    paddingBottom: 10,
    [theme.breakpoints.down("sm")]: {
      padding: 10,
    },
  },
  gridContainer: {
    display: "flex",
    flexDirection: "row",
    padding: 20,
  },
  linkStyle: {
    "&:hover": { cursor: "pointer", textDecoration: "underline" },
  },
});
